import { render, staticRenderFns } from "./cardImport.vue?vue&type=template&id=c765f5f6&scoped=true&"
import script from "./cardImport.vue?vue&type=script&lang=js&"
export * from "./cardImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c765f5f6",
  null
  
)

export default component.exports